/**
 * Modal window component behavior.
 */
import dom from '../helpers/dom';
import scroll from '../helpers/scroll';
import styles from '../helpers/styles';

const modal = () => {
  const modalClass = 'js-qusd-modal';
  const modalClassOpen = 'qusd-modal--open';
  const modalOverlayClass = 'js-qusd-modal-overlay';
  const modalContentClass = 'js-qusd-modal-content';
  const modalCloseButtonClass = 'js-qusd-modal-close-button';
  let modalElement;
  let modalOverlayElement;
  let modalContentElement;
  let modalCloseButtonElement;
  let modalFound = false;

  const modalOpenEventName = 'qustodio:modalOpen';
  const modalCloseEventName = 'qustodio:modalClose';
  let modalEventData = {};
  let isOpen = false;

  /**
   * An optional identifier for the modal window.
   *
   * Can be used to determine what content is being shown in the modal, or
   * which module has triggered the modal to open.
   */
  let modalID = '';

  const getAnimationDuration = () => parseFloat(
    window.getComputedStyle(modalElement).animationDuration,
  ) * 1000;

  const open = (content, id = '') => {
    if (!isOpen) {
      scroll.disableBodyScroll();
      styles.showElement(modalElement);
      modalElement.classList.add(modalClassOpen);
      modalContentElement.append(content);
      modalID = id;
      isOpen = true;
      const modalOpenEvent = new CustomEvent(modalOpenEventName, {
        detail: {
          modalID,
          ...modalEventData,
        },
      });
      window.dispatchEvent(modalOpenEvent);
    }
  };

  const close = () => {
    if (isOpen) {
      modalElement.classList.remove(modalClassOpen);
      setTimeout(() => {
        scroll.enableBodyScroll();
        styles.hideElement(modalElement);
        modalContentElement.innerHTML = '';
        isOpen = false;
        const modalCloseEvent = new CustomEvent(modalCloseEventName, {
          detail: {
            modalID,
            ...modalEventData,
          },
        });
        modalID = '';
        window.dispatchEvent(modalCloseEvent);
      }, getAnimationDuration());
    }
  };

  const onClickOutside = (event) => {
    if (event.target === modalOverlayElement) {
      close();
    }
  };

  const onClickCloseButton = () => close();

  const onPressEscapeKey = (event) => {
    if (event.key === 'Escape') {
      close();
    }
  };

  const init = () => {
    modalElement = dom.getByClassName(modalClass);
    modalFound = modalElement !== null;
    if (modalFound) {
      [modalElement] = modalElement;
      [modalOverlayElement] = dom.getByClassName(modalOverlayClass, modalElement);
      [modalContentElement] = dom.getByClassName(modalContentClass, modalElement);
      [modalCloseButtonElement] = dom.getByClassName(modalCloseButtonClass, modalElement);

      modalEventData = {
        modalElement,
        modalOverlayElement,
        modalContentElement,
        modalCloseButtonElement,
      };

      modalOverlayElement.addEventListener('click', onClickOutside);
      modalCloseButtonElement.addEventListener('click', onClickCloseButton);
      document.addEventListener('keydown', onPressEscapeKey);
    }
  };

  return {
    init,
    open,
    close,
  };
};

export default modal();
